
import safeAssign from './safe-assign';
import map from './map';
import parallel, { handleRecursiveParallel } from './parallel';
import settle from './settle';
import iterator from './iterator';
import doWhilst from './dowhilst';
import retry from './retry';
import series from './series';

export default {
  safeAssign,
  map,
  parallel,
  handleRecursiveParallel,
  settle,
  iterator,
  doWhilst,
  retry,
  series,
}